
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channel",
      function () {
        return require("private-next-pages/channel.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channel"])
      });
    }
  